/**
 * Check certData
 *
 * @param {*} certificate
 * @returns
 */
export function isCertDataValid(certData) {
  return certData?.usuario && certData?.emisor && certData?.numserie && certData?.validezhasta;
}
